@keyframes Pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  23% {
    opacity: 1;
    transform: scale(1);
  }
  30.7% {
    opacity: 1;
    transform: scale(4.9);
  }
  38.4% {
    opacity: 0.7;
    transform: scale(8.8);
  }
  53.8% {
    opacity: 0.1;
    transform: scale(16.6);
  }
  100% {
    opacity: 0;
    transform: scale(40);
  }
}

.PrioAnimation {
  position: absolute;

  animation-duration: 2600ms;
  animation-iteration-count: infinite;
  animation-timing-function: ease-out;
}
